import { LinkItemProps } from '../types/linkItemProps';

export const linkItemsForSubscriptionManager: Array<LinkItemProps> = [
    { name: 'Dashboard', icon: 'table-columns', url: '/dashboard' },
    { name: 'Institutions', icon: 'building-columns', url: '/institutions/list' },
    { name: 'FAM', icon: 'key', url: '/fam/list' },
    { name: 'Trials', icon: 'clock', url: '/trials/list' },
];
